// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2PZF1","text":"SelectPayment_text__3TDPs","title":"SelectPayment_title__1XAdY","btn":"SelectPayment_btn__12d3C"};